import { render } from "./DirectLinks.vue?vue&type=template&id=1cadf65e&scoped=true&ts=true"
import script from "./DirectLinks.vue?vue&type=script&lang=ts"
export * from "./DirectLinks.vue?vue&type=script&lang=ts"

import "./DirectLinks.vue?vue&type=style&index=0&id=1cadf65e&scoped=true&lang=scss"

import exportComponent from "/home/yjmthu/github/vua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cadf65e"]])

export default __exports__